



















import { Vue, Component } from 'vue-property-decorator'
import ChangeStore from '../components/ChangeStore.vue'
import ColumnInfo from '../components/ColumnInfo.vue'
import { GroupItem, ButtonItem } from './types/index'
@Component({
  components: {
    ChangeStore,
    ColumnInfo
  }
})
export default class Index extends Vue {
  private authCount: number = 0
  private defaultColumns: Array<GroupItem> = [
    // 到店车辆
    // {
    //   title: '到店车辆',
    //   authKey: 'car_visit_to_used_car.manage',
    //   hasAuth: false,
    //   items: [
    //     {
    //       name: '车辆转化',
    //       icon: 'car-conversion',
    //       link: '/usedcar/storevehicle'
    //     }
    //   ]
    // },
    // 线索车辆
    // {
    //   title: '线索车辆',
    //   authKey: 'used_car_ticket.manage',
    //   hasAuth: false,
    //   items: [
    //     {
    //       name: '评估跟进',
    //       icon: 'evaluate-followup',
    //       link: '/usedcar/carlist'
    //     },
    //     {
    //       name: '线索询价', // 菜单项名
    //       icon: 'clue-enquiry', // 图标名
    //       link: '/inquiry/inquiryList/inquiry', // 路由跳转地址
    //       authKey: 'used_car_ticket.enquiry.view', // 权限名（需要权限校验时）
    //       hasAuth: false // 权限状态
    //       // needCheckEnableTicketEnquiry: true
    //       // needCheckIsZS: true // 是否校验 是否是中升
    //     },
    //     {
    //       name: '发现本品',
    //       icon: 'discover-own-brand',
    //       link: '/usedcar/ownBrand/list',
    //       authKey: 'used_car_ticket.selfbrand_discovery',
    //       hasAuth: false
    //       // needCheckIsZS: true
    //     }
    //   ]
    // },
    // 车辆管理
    // {
    //   title: '车辆管理',
    //   authKey: 'used_car_car.manage',
    //   hasAuth: false,
    //   items: [
    //     {
    //       name: '全部车辆',
    //       icon: 'all-car',
    //       link: '/auction/carmanage'
    //     },
    //     {
    //       name: '车辆询价',
    //       icon: 'car-enquiry',
    //       link: '/inquiry/inquiryList/auction',
    //       authKey: 'used_car_car.enquiry.view',
    //       hasAuth: false
    //       // needCheckIsZS: true
    //     },
    //     {
    //       name: '车辆拍卖',
    //       icon: 'car-auction',
    //       link: '/auction/manage',
    //       authKey: 'used_car_car.auction.manage',
    //       hasAuth: false
    //       // needCheckIsZS: true
    //     },
    //     {
    //       name: '询价撮合',
    //       icon: 'enquiry-match',
    //       link: '/auction/enquiry/manage',
    //       authKey: 'used_car_car.auction.manage',
    //       hasAuth: false
    //       // needCheckIsZS: true
    //     },
    //     {
    //       name: '流拍撮合',
    //       icon: 'racket-match',
    //       link: '/auction/match/manage',
    //       authKey: 'used_car_car.auction.manage',
    //       hasAuth: false
    //       // needCheckIsZS: true
    //     },
    //     {
    //       name: '出库管理',
    //       icon: 'out-bound-manage',
    //       link: '/outbound/manage',
    //       authKey: 'used_car_outbound.view',
    //       hasAuth: false
    //       // needCheckIsZS: true
    //     },
    //     {
    //       name: '过户管理',
    //       icon: 'transfer-manage',
    //       link: '/transfer/manage',
    //       authKey: 'transfer.manage',
    //       hasAuth: false
    //       // needCheckIsZS: true
    //     },
    //     {
    //       name: '评价管理',
    //       icon: 'rate-manage',
    //       link: '/usedcar/reviewManage',
    //       authKey: 'used_car_review.review.view',
    //       hasAuth: false
    //       // needCheckIsZS: true
    //     }
    //   ]
    // },
    // 业务数据
    {
      title: '业务数据',
      needCheckIsZS: true,
      isKeepInH5: true, // 灰度关闭h5 应用二手车，此入口例外
      items: [
        {
          name: '每日上报',
          icon: 'everyday-report',
          href: 'https://zsuc.lixinchuxing.com', // 地址栏跳转
          isKeepInH5: true // 灰度关闭h5 应用二手车，此入口例外
        }
      ]
    },
    {
      title: '数据统计',
      authKey: 'busi_analysis.zs_used_car_ticket',
      hasAuth: false,
      isKeepInH5: true, // 灰度关闭h5 应用二手车，此入口例外
      items: [
        {
          name: '业务统计',
          icon: 'car-business',
          link: '/manageAnalysis/carBusiness', // 地址栏跳转
          isKeepInH5: true // 灰度关闭h5 应用二手车，此入口例外
        }
      ]
    }
  ]

  public mounted () {
    this.matchAuth()
  }

  private matchAuth () {
    this.$store.state.promiseAuth.then((auth: { authList: string[] }) => {
      const checkAuth = (item: GroupItem|ButtonItem) => {
        if (item.authKey && auth.authList.includes(item.authKey)) {
          item.hasAuth = true
          this.authCount++
        }
      }
      this.defaultColumns.forEach(column => {
        checkAuth(column)
        column.items.forEach(item => checkAuth(item))
      })
    })
    this.$store.commit('UPDATE_AUCTION_MANAGE_STATUS', 'pending')
    // 重置有下拉选项的状态
    this.$store.commit('UPDATE_SELECTSTATUS', '1')
  }
  /**
   * 栏目、条目权限校验
   */
  private checkAuth (item: ButtonItem|GroupItem) {
    // 灰度关闭H5
    if (this.isCloseUsedCarApp) {
      // 校验是否是中升 同时需要校验是否有权限
      if (item.needCheckIsZS) {
        return (item.hasAuth && this.isZS && item.isKeepInH5) || (!item.authKey && this.isZS && item.isKeepInH5)
      }
      return item.isKeepInH5 && (!item.authKey || item.hasAuth)
    }

    // 校验是否是中升 同时需要校验是否有权限
    if (item.needCheckIsZS) {
      return (item.hasAuth && this.isZS) || (!item.authKey && this.isZS)
    }
    // 只检验是否有权限
    return !item.authKey || item.hasAuth
  }

  get isCloseUsedCarApp () {
    const {
      store_config: storeConfig
    } = this.customized || {
      store_config: {}
    }
    // 不直接在变量解析中获取是应为storeConfig有可能为null,而只有undefined才会默认取默认值
    const usedCarH5Enabled = storeConfig && storeConfig.used_car_h5_enabled
    return usedCarH5Enabled
  }

  get hasProvider () {
    return (this.customized || {}).mode === 'provider'
  }
  get columnList () {
    let authColumns: GroupItem[] = []
    const columns = this.defaultColumns.filter(column => {
      return this.checkAuth(column)
    })

    columns && columns.forEach(column => {
      const items = column.items.filter(item => {
        return this.checkAuth(item)
      })

      column.items = items
      authColumns.push(column)
    })

    return authColumns
  }
}
